import html2canvas from 'html2canvas';

const usePrintBarcode = ({ wrapperRef }) => {
  const opt = {
    scale: 3,
  };

  const onPrint = () => {
    const elem = wrapperRef.current;
    html2canvas(elem, opt).then((canvas) => {
      const iframe = document.createElement('iframe');
      iframe.name = 'printf';
      iframe.id = 'printf';
      iframe.height = 0;
      iframe.width = 0;
      document.body.appendChild(iframe);

      const imgUrl = canvas.toDataURL('jpeg', '1.0');

      const style = `
            height: auto;
            width: 100px;
            objectFit: cover;
            position:absolute;
            left:0;
            top:0;
        `;

      const url = `<img style="${style}" src="${imgUrl}"/>`;
      const newWin = window.frames['printf'];
      newWin.document.write(`<body onload="window.print()">${url}</body>`);
      newWin.document.close();
    });
  };

  const downloadFull = () => {
    const elem = wrapperRef.current;
    html2canvas(elem, opt).then((canvas) => {
      const pngUrl = canvas
        .toDataURL('image/png')
        .replace('image/png', 'image/octet-stream');
      let downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = 'mybarcode.png';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };

  return {
    onPrint,
    downloadFull,
  };
};

export default usePrintBarcode;
